import { normalizeDisplayCount } from "@/lib/liveBroadcast";

export function batchFromLiveData(data) {
  if (!data) return [];
  const displayCount = normalizeDisplayCount(data.live?.display_count);
  const raw = data.current_batch?.length
    ? data.current_batch
    : (data.current ? [data.current] : []);
  return raw.slice(0, displayCount);
}

/** One calling sequence = one student category (matches backstage category boundaries). */
export function sequenceKey(batch) {
  if (!batch?.length) return null;
  const catId = batch[0]?.student_category_id;
  if (catId != null) return `cat:${catId}`;
  const program = (batch[0]?.program || "").trim();
  const spec = (batch[0]?.specialization || "").trim();
  return `lbl:${program}|${spec}`;
}

/** Ignore placeholder specialization values on the projection screen. */
function displaySpecialization(spec) {
  const value = (spec || "").trim();
  if (!value || value.toLowerCase() === "default") return "";
  return value;
}

export function sequenceLabel(batch) {
  if (!batch?.length) return "";
  const s = batch[0];
  const program = (s.program || "").trim();
  const spec = (s.specialization || "").trim();
  if (program && spec) return `${program} · ${spec}`;
  return program || spec || (s.entity || "").trim() || "Convocation";
}

/** Full announcer line shown on the sequence home projection screen. */
export function sequenceStartingStatement(batch) {
  if (!batch?.length) return "The following are our graduating students";
  const s = batch[0];
  const program = (s.program || "").trim();
  const spec = displaySpecialization(s.specialization);
  if (program && spec) {
    return `The following are students graduating from the ${program} program in ${spec}`;
  }
  if (program) {
    return `The following are students graduating from the ${program} program`;
  }
  if (spec) {
    return `The following are students graduating in ${spec}`;
  }
  const entity = (s.entity || "").trim();
  if (entity) {
    return `The following are students graduating from ${entity}`;
  }
  return "The following are our graduating students";
}

export function sequenceEntity(batch) {
  if (!batch?.length) return "";
  return (batch[0]?.entity || "").trim();
}

/**
 * Plan announcer display steps when live data changes.
 * Returns [] for immediate names, or ['starting'] when entering a new sequence.
 */
export function planSequenceSigns(previousBatch, nextBatch) {
  if (!nextBatch.length) return [];
  const prevKey = sequenceKey(previousBatch);
  const nextKey = sequenceKey(nextBatch);
  if (!prevKey) return ["starting"];
  if (prevKey === nextKey) return [];
  return ["starting"];
}
